import Component from 'flarum/common/Component';
import ItemList from 'flarum/common/utils/ItemList';
export default class PollSubtitle extends Component {
  view() {
    if (!this.attrs.poll.subtitle()) {
      return;
    }
    return m("div", {
      className: "Poll-subtitle-component"
    }, this.pollSubtitleItems().toArray());
  }
  pollSubtitleItems() {
    const items = new ItemList();
    items.add('subtitle', m("p", {
      className: "Poll-subtitle"
    }, this.attrs.poll.subtitle()));
    return items;
  }
}
flarum.reg.add('fof-polls', 'forum/components/Poll/PollSubtitle', PollSubtitle);